import { render, staticRenderFns } from "./MapTabFav.vue?vue&type=template&id=b386cc52"
import script from "./MapTabFav.vue?vue&type=script&lang=js"
export * from "./MapTabFav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports